var bindEventsInCart = function () {
  var t = $(".modal-popup form");
  ($additionCheckoutBlock = t.find("#additional-checkout-block")),
    $additionCheckoutBlock.load("/cart #addCheckoutBtn", function () {
    window.Shopify && Shopify.StorefrontExpressButtons && Shopify.StorefrontExpressButtons.initialize();
  }),
    $(".cart_menu").on("click", ".remove_item_button", function (t) {
    t.preventDefault();
    var e = $(this).data("id") || null;
    var line = $(this).data("line") || null;
    Shopify.removeItemLine(line, function (t) {
      Shopify.updateQuickCart(t);
    });
  }),
    jQuery(".cart_menu").on("click", ".minus_btn", function () {
    var t = jQuery(this).parent().find("input"),
        e = t.val();
    jQuery(this).parent().hasClass("minus_btn") ? e++ : e--, e < 0 && (e = 0), t.val(e);
    var a = e,
        i = t.data("id"),
        line = t.data("line")*1;
    0 != a
    ? Shopify.changeItemByLine(line, a, function (t) {
      Shopify.updateQuickCart(t);
    })
    : Shopify.removeItemLine(line, function (t) {
      Shopify.updateQuickCart(t);
    });
  }),
    jQuery(".cart_menu").on("click", ".plus_btn", function () {
    var t = jQuery(this).parent().find("input"),
        e = t.val();
    jQuery(this).hasClass("plus_btn") ? e++ : e--, e < 0 && (e = 0);
    var a = e,
        i = t.data("id"),
        line = t.data("line")*1;
    Shopify.changeItemByLine(line, a, function (e) {
      var n = e.items.filter(function (t) {
        return t.variant_id == i;
      });
      n.length && n[0].quantity == a
      ? (Shopify.updateQuickCart(e), t.val(a))
      : jQuery(".ajaxcart__item__" + i + "__errors")
      .show()
      .delay(2e3)
      .fadeOut();
      location.reload();
    });
  }),
    jQuery(".cart_menu").on("keyup", ".number_val_input", function (t) {
    this.value = this.value.replace(/[^0-9]/g, "");
  }),
    jQuery(".cart_menu").on("change", ".number_val_input", function (t) {
    var e = $(this),
        a = e.val().replace(/[^0-9]/g, ""),
        line = e.data("line")*1;
    (id = e.data("id")),
      a > 0
    ? Shopify.changeItemByLine(line, a, function (t) {
      var i = t.items.filter(function (t) {
        return t.variant_id == id;
      });
      i.length && i[0].quantity == a
      ? (Shopify.updateQuickCart(t), e.val(a))
      : jQuery(".ajaxcart__item__" + id + "__errors")
      .show()
      .delay(2e3)
      .fadeOut();
    })
    : Shopify.removeItemLine(line, function (t) {
      Shopify.updateQuickCart(t);
    });
  }),
    $(".cart_menu").on("focusout", "textarea", function () {
    var t = $(this).val(),
        e = $(".div.cart_menu").find("textarea").add($(".cart_tbl textarea"));
    Shopify.updateCartNote(t, function () {
      $(e).each(function () {
        $(this).val(t), $(this).text(t);
      });
    });
  }),
    $(".cart_menu").on("click", ".info_btn", function () {
    var t = $.magnificPopup.instance;
    void 0 !== t && t.close();
  }),
    $(".cart_menu").on("click", ".btn_close", function () {
    var t = $.magnificPopup.instance;
    void 0 !== t && t.close();
  });
};
jQuery(document).ready(function () {
  var t = jQuery,
      e = ".count",
      a = "form[name=cartform]",
      i = "form[name=cartform] input[name=update]",
      n = "input[type=image], input.button-update-cart",
      r = ".cart-line-item",
      o = ".remove a",
      c = "div.cart_menu",
      l = ".cart_tbl";
  (window.formatMoney = function (t) {
    return Shopify.formatMoney(t, app.data.money_format);
  }),
    t(i).click(function (e) {
    e.preventDefault(), t(e.target.form).find(n).attr("disabled", !0).addClass("disabled"), Shopify.updateCartFromForm(e.target.form);
  }),
    t(a).delegate(o, "click", function (e) {
    e.preventDefault();
    var a = this.href.split("/").pop().split("?").shift();
    Shopify.removeItem(a), t(this).parents(r).remove();
  }),
    (Shopify.modalTimer = !1),
    (Shopify.showModal = function (t, e) {
    $("html").css("overflow-y", "hidden"),
      "function" == typeof $().magnificPopup &&
      void 0 !== t &&
        ($.magnificPopup.open({
        items: { src: '<div class="mfp-with-anim modal-popup">' + t + "</div>", type: "inline" },
        mainClass: "mfp-move-from-top",
        removalDelay: 1e3,
        callbacks: {
          close: function () {
            $("html").css("overflow-y", "auto");
          },
        },
      }),
         bindEventsInCart());
  }),
    (Shopify.addImageSize = function (t, e) {
    return void 0 === e ? t : null === t ? "//cdn.shopify.com/s/files/1/0033/4348/2998/t/6/assets/no-image.gif?9441885048570410025" : ((e = "_" + e + "."), t.replace(/.([^.]*)$/, e + "$1"));
  }),
    (Shopify.updateQuickCart = function (e) {
    var a = t(c),
        i = t(l);
    if (a.length)
      if (e.items.length) {
        for (var n = [], r = "<ul><li>Photo</li><li>Name</li><li>Price</li><li>Quantity</li><li>Total</li></ul>", o = 0; o < e.items.length; o++) {
          var u = e.items[o].price,
              p = e.total_price,
              s = e.items[o].line_price,
              d = e.items[o].variant_title,
              f = e.note,
              m = e.items[o].properties || null;
          if (null != m) {
            var h = "";
            _.forOwn(m, function (t, e) {
              if(!_.includes(e, "_options")){                   
                h = _.includes(t, "/uploads/") ? h + e + ": <a href='" + t + "'>" + _.last(t.split("/")) + "</a><br/>" : h + e + ": " + t + "<br/>";
              }
                });
          } else h = "";
          
        
          null == d && (d = ""), null == f && (f = "");
          var y = Shopify.formatMoney(u, app.data.money_format),
              v = Shopify.formatMoney(p, app.data.money_format),
              S = Shopify.formatMoney(s, app.data.money_format);
          if ("undefined" != typeof Currency && shopCurrency && cookieCurrency) {
            var b = Currency.convert(u, shopCurrency, cookieCurrency);
            y = Shopify.formatMoney(b, Currency.moneyFormats[cookieCurrency].money_format);
            var C = Currency.convert(p, shopCurrency, cookieCurrency);
            v = Shopify.formatMoney(C, Currency.moneyFormats[cookieCurrency].money_format);
            var k = Currency.convert(s, shopCurrency, cookieCurrency);
            S = Shopify.formatMoney(k, Currency.moneyFormats[cookieCurrency].money_format);
          }
          var g =
              '<ul><li><div class="thumb"><a href="' +
              e.items[o].url +
              '"><img src="' +
              Shopify.addImageSize(e.items[o].image, "small") +
              '" alt="' +
              e.items[o].title +
              '"></a></div></li><li><h5><a href="' +
              e.items[o].url +
              '" class="item-name">' +
              e.items[o].product_title +
              '</a></h5><p class="product-type">' +
              d +
              "</p><p>" +
              h +
              '</p><a href="#" data-id="' +
              e.items[o].id +
              '" class="remove_item_button" data-id="' + e.items[o].id + '" data-line="' + (o + 1) +'">Remove</a></li><li><p class="mobile-label-price">Price</p><span class="money price">' +
              y +
              '</span></li><li><p class="mobile-label-quantity">Quantity</p><a class="minus_btn"></a><input type="text" name="updates[]" class="txtbox number_val_input" min="0" id="updates_' +
              e.items[o].id +
              '" data-id="' +
              e.items[o].id +
              '" data-line="' +
              (o + 1) +
              '" value="' +
              e.items[o].quantity +
              '" /><a class="plus_btn"></a><div class="ajaxcart__errors text-center ajaxcart__item__' +
              e.items[o].id +
              '__errors">All available stock is in cart</div></li><li><p class="mobile-label-total">Total</p><span class="money price">' +
              S +
              "</span></li></ul>";
          n.push(g);
        }
        var Q = a.find("div.checkout_row"),
            j = a.find("span.total-price"),
            x = i.find("span.total-price");
        if (Q.length) a.find("div.cart_row").html(n.join("")), a.find("div.cart_row").prepend(r), i.find(".con_row").html(n.join("")), x.html(v), j.html(v);
        else {
          (Q =
           '<div class="checkout_row clearfix"><button type="submit" name="checkout" value="Check Out" class="btn_c">Check Out</button> <a href="javascript:void(0)" class="info_btn"><span class="fa fa-chevron-left"></span>Continue Shopping</a></div>'),
            (j = '<div class="total_row clearfix"><ul><li><span class="total_val">Subtotal:</span><span class="money total-price">' + v + "</span></li></ul></div>");
          var w = t("<form />", { action: "/cart", method: "post", novalidate: "novalidate" }),
              I = currencyNoteCompiled,
              M =
              '<div class="clearfix order_notes"><label for="cartSpecialInstructions" class="sr-only">Order Notes:</label><textarea name="note" id="cartSpecialInstructionsFromPopup" class="note_text" placeholder="Order Notes">' +
              f +
              "</textarea></div>";
          w.append($("div.cart_row")),
            w.find("div.cart_row").html(n.join("")),
            w.find("div.cart_row").prepend(r),
            w.append(j),
            w.append(M),
            w.append(I),
            w.append(Q),
            w.append('<div id="additional-checkout-block" class="text-right" ></div>'),
            a.append(w);
        }
      } else
        a.html(
          '<div class="menu_title clearfix"><h4>Shopping Cart</h4> </div><div class="cart_row"><div class="empty-cart">Your cart is currently empty.</div><p><a href="javascript:void(0)" class="btn_c btn_close">Continue Shopping</a></p></div>'
        ),
          i.html('<div class="empty-cart-message"><p>Your cart is currently empty.</p><p><a href="/collections/all" class="btn_c">Continue Shopping</a></p></div');
    $(l).length ||
      setTimeout(function () {
      Shopify.showModal($(c).wrap("<p>").parent().html());
    }, 500),
      Shopify.onCartUpdate(e);
  }),
    (Shopify.onCartUpdate = function (a, i) {
    var n = a.item_count;
    a.item_count > 0 ? t(e).text(n).removeClass("hidden") : t(e).text("").addClass("hidden");
  }),
    (Shopify.onError = function (t, e) {
    var a = jQuery.parseJSON(t.responseText).description;
    "function" != typeof $().magnificPopup
    ? alert(a)
    : $.magnificPopup.open({ items: { src: '<div class="mfp-with-anim modal-popup error"><h3>Error</h3>' + a + "</div>", type: "inline" }, mainClass: "mfp-move-from-top", removalDelay: 1e3 });
  }),
    $(".cart_tbl").on("focusout", "textarea", function () {
    var e = $(this).val();
    t(c).find("textarea");
    Shopify.updateCartNote(e);
  }),
    jQuery(".cart_tbl").on("click", ".plus_btn", function () {
    var t = jQuery(this).parent().find("input"),
        e = t.val();
    jQuery(this).hasClass("plus_btn") ? e++ : e--, e < 0 && (e = 0);
    var a = e,
        i = t.data("id"),
        line = t.data("line")*1;
    Shopify.changeItemByLine(line, a, function (e) {
      var n = e.items.filter(function (t) {
        return t.variant_id == i;
      });
      n.length && n[0].quantity == a
      ? (Shopify.updateQuickCart(e), t.val(a))
      : jQuery(".ajaxcart__item__" + i + "__errors")
      .show()
      .delay(3e3)
      .fadeOut();
    });
  }),
    jQuery(".cart_tbl").on("click", ".minus_btn", function () {
    var t = jQuery(this).parent().find("input"),
        e = t.val();
    jQuery(this).parent().hasClass("minus_btn") ? e++ : e--, e < 0 && (e = 0), t.val(e);
    var a = e,
        i = t.data("id"),
        line = t.data("line")*1;
    0 != a
    ? Shopify.changeItemByLine(line, a, function (t) {
      Shopify.updateQuickCart(t);
    })
    : Shopify.removeItemLine(line, function (t) {
      Shopify.updateQuickCart(t);
    });
  }),
    $(".cart_tbl").on("click", ".remove_item_button", function (t) {
    t.preventDefault();
    var e = $(this).data("id") || null;
    var line = $(this).data("line") || null;

    Shopify.removeItemLine(line, function (t) {
      Shopify.updateQuickCart(t);
    });
  }),
    jQuery(".cart_tbl").on("keyup", ".number_val_input", function (t) {
    this.value = this.value.replace(/[^0-9]/g, "");
  }),
    jQuery(".cart_tbl").on("change", ".number_val_input", function (t) {
    var e = $(this),
        a = e.val().replace(/[^0-9]/g, ""),
        line = e.data("line")*1;
    (id = e.data("id")),
      a > 0
    ? Shopify.changeItemByLine(line, a, function (t) {
      var i = t.items.filter(function (t) {
        return t.variant_id == id;
      });
      i.length && i[0].quantity == a
      ? (Shopify.updateQuickCart(t), e.val(a))
      : jQuery(".ajaxcart__item__" + id + "__errors")
      .show()
      .delay(2e3)
      .fadeOut();
    })
    : Shopify.removeItemLine(line, function (t) {
      Shopify.updateQuickCart(t);
    });
  });
});
